const Colors = {
  dark: {
    '--dark-bg-color': '#020c1b',
    '--bg-color': '#0a192f',
    '--light-bg-color': '#112240',
    '--lightest-bg-color': '#233554',
    '--bg-color-shadow': 'rgba(2, 12, 27, 0.7)',
    '--dark-text-color': '#495670',
    '--text-color': '#8892b0',
    '--light-text-color': '#a8b2d1',
    '--lightest-text-color': '#ccd6f6',
    '--contrast-color': '#e6f1ff',
    '--primary-color': '#22d3ee',
    '--primary-color-tint': 'rgba(34, 211, 238, 0.1)',
    '--highlight-tint': 'rgba(34, 211, 238, 0.1)',
    '--outline-light': 'rgba(34, 211, 238, 0.4)',
  },
  light: {
    '--dark-bg-color': '#f2f2f2',
    '--bg-color': '#ffffff',
    '--light-bg-color': '#f1f5f9',
    '--lightest-bg-color': '#c7c7c7',
    '--bg-color-shadow': 'rgba(148, 148, 148, 0.7)',
    '--dark-text-color': '#07090d',
    '--text-color': '#676f85',
    '--light-text-color': '#39393b',
    '--lightest-text-color': '#1c2333',
    '--contrast-color': '#1c1d1f',
    '--primary-color': '#3b83f6',
    '--primary-color-tint': 'rgba(59, 131, 246, 0.1)',
    '--highlight-tint': 'rgba(59, 131, 246, 0.1)',
    '--outline-light': '#e2e8f0',
  },
};

export default Colors;
